import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';
import PublicSettings from '@api/requests/publicSettings/interfaces/PublicSettings.interface';

export type GetPublicSettingsData = void;

export interface GetPublicSettingsResponse {
	settings: PublicSettings;
	status: number;
}

const getPublicSettings = configRequest<GetPublicSettingsResponse, GetPublicSettingsData>({
	requestPrefix: 'publicSettings/getPublicSettings',
	reqConfigCreator: () => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.PUBLIC_SETTINGS.GET(),
		method: HTTP_METHODS_ENUM.GET,
	}),
});

export default getPublicSettings;
